import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "relative w-full max-w-5xl px-4" }
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 transition-opacity",
    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        class: "absolute top-4 right-4 text-white bg-gray-800 rounded-full p-2 hover:bg-gray-700 transition-colors hover:text-blue-400"
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("line", {
            x1: "18",
            y1: "6",
            x2: "6",
            y2: "18"
          }),
          _createElementVNode("line", {
            x1: "6",
            y1: "6",
            x2: "18",
            y2: "18"
          })
        ], -1)
      ])),
      _createElementVNode("div", {
        class: "max-h-screen flex items-center justify-center",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("img", {
          src: _ctx.getImageUrl(_ctx.currentImage),
          alt: _ctx.product?.name,
          class: "max-h-[80vh] max-w-full object-contain shadow-2xl"
        }, null, 8, _hoisted_2)
      ]),
      (_ctx.product && _ctx.product.pictures && _ctx.product.pictures.length > 1)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "absolute inset-x-0 top-1/2 transform -translate-y-1/2 flex justify-between px-4",
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToPreviousImage && _ctx.navigateToPreviousImage(...args)), ["stop"])),
              class: "bg-gray-800 hover:bg-gray-700 rounded-full p-3 text-white focus:outline-none transition-colors hover:text-blue-400"
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M15 18l-6-6 6-6" })
              ], -1)
            ])),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToNextImage && _ctx.navigateToNextImage(...args)), ["stop"])),
              class: "bg-gray-800 hover:bg-gray-700 rounded-full p-3 text-white focus:outline-none transition-colors hover:text-blue-400"
            }, _cache[9] || (_cache[9] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("path", { d: "M9 18l6-6-6-6" })
              ], -1)
            ]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-gray-800 bg-opacity-80 px-4 py-2 rounded-full text-white shadow-md",
        onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, _toDisplayString(_ctx.currentImageIndex + 1) + " / " + _toDisplayString(_ctx.product?.pictures?.length), 1)
    ])
  ]))
}